// extracted by mini-css-extract-plugin
export default {"separator":"RDkQjHE0","Group":"gdqjBFZA","SidebarNav":"Vlej5z_0","Item":"kXVe7BEH"};